export function CatalogStatus({ label, code }: { label: string; code?: string | null }) {
  const tone = code === 'active' ? 'positive' : 'neutral';
  return <span className={`catalog-status catalog-status_${tone}`}>{label}</span>;
}
